import type { TrackingInterface } from "@pdfking/taskmaker"

export const RegisteredCallbacks: TrackingInterface[] = []

export const RegisterCallbacks = (functions: TrackingInterface) =>
  RegisteredCallbacks.push(functions)
